import { render, staticRenderFns } from "./CustomerActivity.vue?vue&type=template&id=3fd9d668&scoped=true&"
import script from "./CustomerActivity.vue?vue&type=script&lang=js&"
export * from "./CustomerActivity.vue?vue&type=script&lang=js&"
import style0 from "./CustomerActivity.vue?vue&type=style&index=0&id=3fd9d668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd9d668",
  null
  
)

export default component.exports